/* Peter and May - euro / dollar display switch (footer + mobile drawer).

   The store charges in euros and only in euros : the 236 countries of
   localization.available_countries all price in EUR, so Shopify converts
   nothing and offers no currency to switch. The dollar figures are the brand's
   own RRP, read off custom.prix_rrp_usd and printed next to every euro price by
   snippets/pm-money.liquid.

   So there is nothing to submit and nothing to reload : both amounts are
   already in the page, CSS shows one, and this file only moves the
   data-currency attribute on <html> and remembers the choice. The attribute
   itself is set before the first paint by the inline script in
   layout/theme.liquid - by the time this deferred module runs the page is
   already showing the right currency, and all it adds is the interaction.

   Consequence worth keeping in mind : anything the server re-renders later (the
   cart drawer, a section fetched through the Section Rendering API) comes back
   with both currencies in it and is styled by the same CSS, so no re-apply is
   needed. Only the two scripts that overwrite a price cell's textContent by
   hand need care - see assets/pm-header.js. */
(() => {
  const KEY = 'pm-currency';
  const SELECT = '[data-currency-select]';

  const normalise = (value) => (value === 'usd' ? 'usd' : 'eur');

  const current = () => normalise(document.documentElement.dataset.currency);

  /* Private browsing and blocked site data make these throw rather than fail
     quietly, and the switch has to keep working without persistence. */
  const remember = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {
      /* choice holds for this page only */
    }
  };

  /* The selects are rendered with the MARKET default selected, because the page
     is cached for everybody : a visitor who has chosen otherwise needs them put
     right. Done for every select at once so the footer and the drawer never
     disagree. */
  const syncSelects = (value) => {
    document.querySelectorAll(SELECT).forEach((select) => {
      if (select.value !== value) select.value = value;
    });
  };

  const apply = (value, persist) => {
    const next = normalise(value);
    document.documentElement.dataset.currency = next;
    if (persist) remember(next);
    syncSelects(next);
    document.dispatchEvent(new CustomEvent('pm:currency', { detail: { currency: next } }));
  };

  /* Delegated : the theme editor re-renders the footer section and the drawer
     snippet on every setting change, and the drawer markup itself is swapped
     around, so a bound listener would not survive. */
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches(SELECT)) return;
    apply(select.value, true);
  });

  syncSelects(current());

  /* A section re-rendered by the editor brings back a select on the market
     default again. Same correction, same reason as on load. */
  document.addEventListener('shopify:section:load', () => syncSelects(current()));
})();
